/**
 * Shared styles for filter components.
 * Extracted from FilterBar.jsx so sub-components can import without circular deps.
 */

export const selectStyle = {
  background: 'var(--glass)',
  border: '1px solid var(--bdr)',
  borderRadius: 8,
  padding: '6px 10px',
  fontSize: 12,
  color: 'var(--t1)',
  outline: 'none',
  minHeight: 44,
  cursor: 'pointer',
};
